var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0028 3.19314C6.82724 3.18962 5.6907 3.61466 4.80592 4.38869C3.92115 5.16273 3.34879 6.23268 3.19601 7.39828C3.16012 7.67208 2.90907 7.86494 2.63527 7.82905C2.36147 7.79316 2.1686 7.54211 2.20449 7.26831C2.38889 5.86156 3.07965 4.57023 4.14749 3.63606C5.21532 2.70188 6.58701 2.1889 8.00579 2.19314C9.42457 2.19738 10.7932 2.71856 11.8554 3.6591C12.9176 4.59965 13.6007 5.89508 13.7766 7.30291C13.9526 8.71074 13.6095 10.1345 12.8115 11.3075C12.0134 12.4806 10.8152 13.3226 9.44115 13.676C8.06707 14.0293 6.61131 13.8698 5.34638 13.2272C4.48159 12.7879 3.74653 12.1434 3.20025 11.3584V13.3333C3.20025 13.6094 2.97639 13.8333 2.70025 13.8333C2.42411 13.8333 2.20025 13.6094 2.20025 13.3333V9.99996C2.20025 9.72382 2.42411 9.49996 2.70025 9.49996H3.02193C3.02962 9.49978 3.03729 9.49978 3.04494 9.49996H6.03359C6.30973 9.49996 6.53359 9.72382 6.53359 9.99996C6.53359 10.2761 6.30973 10.5 6.03359 10.5H3.83588C4.30098 11.2807 4.97984 11.9194 5.79929 12.3356C6.84737 12.8681 8.05357 13.0003 9.1921 12.7075C10.3306 12.4147 11.3234 11.717 11.9846 10.7451C12.6459 9.77308 12.9302 8.59343 12.7844 7.42695C12.6385 6.26046 12.0726 5.1871 11.1925 4.40779C10.3123 3.62848 9.17836 3.19665 8.0028 3.19314Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCircle);
export default __webpack_public_path__ + "static/media/rotate_circle.22d13caad90b2c209697113fc63346c3.svg";
export { ForwardRef as ReactComponent };